import { REDUCER_KEY } from "./preference.constants";
export var getPreferences = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].json
        : false;
};
export var hasPreferences = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].hasPreference
        : false;
};
export var isFetchingPreferences = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].isFetching
        : false;
};
export var fetchPreferenceError = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].fetchError
        : undefined;
};
export var isCreatingPreference = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].isCreating
        : false;
};
export var createPreferenceError = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].createError
        : undefined;
};
export var isUpdatingPreference = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].isUpdating
        : false;
};
export var updatePreferenceError = function (state, key) {
    return state[REDUCER_KEY].preferences[key]
        ? state[REDUCER_KEY].preferences[key].updateError
        : undefined;
};
